import useAccessControl from 'api/useAccessControl/useAccessControl';
import { useSelectedDealerId } from '@lotlinx-aws/dealer-selector';
import { useAtom } from 'jotai';
import { userAtom } from 'store';
import { AccountType } from 'types/User';
import { isVmbiSubscriptionExemptDealer } from 'util/vmbiSubscriptionExemptDealers';

export default function useAccess() {
  const { data, isLoading, error } = useAccessControl();
  const [user] = useAtom(userAtom);
  const [dealerId] = useSelectedDealerId();
  const isExemptDealer = isVmbiSubscriptionExemptDealer(dealerId);

  return {
    data,
    isLoading,
    error,
    isVmbiSubscribedOnly:
      !isExemptDealer && data?.isVmbiSubscribedOnly && user?.accountType !== AccountType.OWNER
        ? true
        : false,
  };
}
